export var isOneNoteNotebook = function (graphItemOrNotebook) {
    return graphItemOrNotebook.links !== undefined;
};
//# sourceMappingURL=isOneNoteNotebook.js.map